/* REVIEW GLANCE */

function checkReviews(){
  console.log($('#stamped-reviews-tab .stamped-review'));
  if($('#stamped-reviews-tab .stamped-review').first().length){
  var reviewText = $('#stamped-reviews-tab .stamped-review').first().find(".stamped-review-body").text().substring(0, 150) + "...";
  var reviewAuthor = $('#stamped-reviews-tab .stamped-review').first().find(".author").text();
    
  $(".product-ratings").append("<div class='review-text'>" + '"' + reviewText + '"' + "</div>");
  $(".product-ratings").append("<div class='review-author'>" + reviewAuthor + "</div>");
  $(".template-product .stars-review-glance .review-text").html("&quot;"+reviewText+"&quot;");
  $(".template-product .stars-review-glance .review-author").text(reviewAuthor);    
  
  clearInterval(myInterval);  
  }
  
}




myInterval = setInterval(checkReviews, 500);



/* READ MORE SCROLL */
document.addEventListener("DOMContentLoaded", (event) => {

  $(".short-desc .read-more").click(function() {
    var toY = parseInt($("#product-details").offset().top - 120);
      $('html, body').animate({
          scrollTop: toY
      }, 500);
  });

  $(".product-ratings").click(function() {
    var toY = parseInt($(".product-reviews--content").offset().top - 120);
      $('html, body').animate({
          scrollTop: toY
      }, 500);
  });
  
});
